/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import { isEmpty } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Optioner from 'components/shared/Optioner/Optioner';
import { activePlusAccountUrl } from 'services/Externals';
import {
  ACTIVE_ADVISORY,
  ACTIVE_PLUS,
  BROKERAGE,
  MUTUAL_FUND,
  isCollegeSavings
} from 'services/Products';
import BrokerageLink from 'components/shared/Table/BrokerageLink';
import {
  getCustomerWebView,
  getUberId
} from 'state/customer/CustomerSelectors';
import { getView } from 'state/view/ViewSelectors';

const COLLEGE_SAVINGS = 'COLLEGE_SAVINGS';

const ActivePlusLink = ({
  accountId,
  accountName,
  isHolding,
  isCWV,
  uberId
}) => {
  if (isHolding) {
    return accountName;
  }

  const url = activePlusAccountUrl(accountId, isCWV, uberId);
  return (
    <a className="app-link prevent-wrap" href={url}>
      <span className="link-text">{accountName}</span>
    </a>
  );
};

const ActiveAdvisory = () => {
  return <span>Retirement Advisory Service</span>;
};

const MutualFundLink = ({ accountId, accountName }) => {
  if (isEmpty(accountId)) {
    return accountName;
  }

  return (
    <Link className="app-link" to={`/account-details?id=${accountId}`}>
      <span className="link-text">{accountName}</span>
    </Link>
  );
};

const CollegeSavingsLink = ({ accountName, accountId }) => (
  <Link className="app-link" to={`/account-details?id=${accountId}`}>
    <span className="link-text">{accountName}</span>
  </Link>
);

const AccountName = ({
  productType,
  accountName,
  accountId,
  isHolding = false,
  uberId,
  view
}) => (
  <Optioner val={isCollegeSavings(productType) ? COLLEGE_SAVINGS : productType}>
    {{
      [ACTIVE_ADVISORY]: () => <ActiveAdvisory />,
      [ACTIVE_PLUS]: () => (
        <ActivePlusLink
          accountId={accountId}
          accountName={accountName}
          isHolding={isHolding}
          uberId={uberId}
        />
      ),
      [BROKERAGE]: () => (
        <BrokerageLink
          accountId={accountId}
          accountName={accountName}
          isHolding={isHolding}
        />
      ),
      [MUTUAL_FUND]: () => (
        <MutualFundLink
          accountId={accountId}
          accountName={accountName}
          view={view}
        />
      ),
      [COLLEGE_SAVINGS]: () => (
        <CollegeSavingsLink accountId={accountId} accountName={accountName} />
      ),
      _: accountName
    }}
  </Optioner>
);

const mapStateToProps = (state) => ({
  isCWV: getCustomerWebView(state),
  uberId: getUberId(state),
  view: getView(state)
});

export default connect(mapStateToProps)(AccountName);
